<section class="rs-section ty" rsParallax>
  <div class="rs-deco" aria-hidden="true">
    <span class="rs-blob rs-blob--pink rs-blob--tl"></span>
    <span class="rs-blob rs-blob--purple rs-blob--tr"></span>
    <span class="rs-blob rs-blob--indigo rs-blob--br"></span>
    <span class="rs-dots rs-dots--a"></span>
    <span class="rs-dots rs-dots--pink rs-dots--b"></span>
    <span class="rs-ring rs-ring--a"></span>
    <span class="rs-ring rs-ring--b"></span>
    <span class="rs-spark" style="--sx: 20%; --sy: 20%; --sd: 0s"></span>
    <span class="rs-spark" style="--sx: 78%; --sy: 28%; --sd: 1.2s"></span>
    <span class="rs-spark" style="--sx: 34%; --sy: 78%; --sd: 2.4s"></span>
    <span class="rs-spark" style="--sx: 66%; --sy: 84%; --sd: 3.4s"></span>
  </div>

  <div class="thank-you-bg my-4 rs-shell">
        <div class="content">
          <div class="thank_wrapper" rsReveal="up" rsRevealImmediate>
            <span class="ty__seal" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M4 12.5l5 5L20 6.5" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>

            <img loading="lazy" src="assets/images/thank-you.jpg" alt="thank-you"/>

            <h1 class="animate-charcter">
              Thank Y<i class="far fa-grin-hearts bounce"></i>u!
            </h1>
            <span class="rs-rule rs-rule--center" aria-hidden="true"></span>
            <p>
              <!-- Congratulation, <i class="fa fa-thumbs-o-up" style="font-size:24px; transform: translateY(2px);"></i> <br> -->
    We’re glad to inform you that we have confirmed your payment,
    have a great day. Thank you for visiting here.
            </p>

            <div class="ty__actions">
              <a routerLink="/" class="rs-btn rs-btn--primary" rsRipple>
                <span>Back to home</span>
                <span class="rs-btn__icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path d="M5 12h13M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.2"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </span>
              </a>
              <a routerLink="/contact-us" class="rs-btn rs-btn--ghost rs-btn--flat">
                Contact support
              </a>
            </div>
            <!-- <a href="#" class="go-home">Home Page</a> -->
            <!-- <div id="cursor"></div> -->
          </div>
        </div>
      </div>
</section>
